import store from '@store';
import {
  INDRIVE_ID_PARENT_ORIGIN,
  INDRIVE_PARENT_ORIGINS,
} from '@core/helpers/constants';

export {INDRIVE_ID_PARENT_ORIGIN, INDRIVE_PARENT_ORIGINS};

export const normalizeOrigin = (origin: string): string => {
  try {
    return new URL(origin).origin;
  } catch {
    return origin.replace(/\/+$/, '');
  }
};

export const isAllowedIndriveOrigin = (
  origin: string,
  allowedOrigins: string[] = INDRIVE_PARENT_ORIGINS
): boolean => {
  if (allowedOrigins.includes('*')) {
    return true;
  }
  const normalizedIncoming = normalizeOrigin(origin);
  return allowedOrigins.some(
    (allowed) => normalizeOrigin(allowed) === normalizedIncoming
  );
};

export const getIndriveTargetOrigin = (
  allowedOrigins: string[] = INDRIVE_PARENT_ORIGINS,
  referrer: string = typeof document !== 'undefined' ? document.referrer : ''
): string => {
  if (allowedOrigins.includes('*')) {
    return '*';
  }

  if (referrer) {
    const normalizedReferrer = normalizeOrigin(referrer);
    const matched = allowedOrigins.find(
      (allowed) => normalizeOrigin(allowed) === normalizedReferrer
    );
    if (matched) {
      return normalizeOrigin(matched);
    }
  }

  return allowedOrigins[0] ? normalizeOrigin(allowedOrigins[0]) : '*';
};

export const isIndriveIndonesia = () => {
  const {login, dashboard} = store.getState();
  return (
    login.countryCode === 'ID' &&
    (login.theme === 'indrive' || dashboard.isIndrive)
  );
};

export const postIndriveMessage = (
  message: {type: string; payload: Record<string, unknown>},
  legacyTargetOrigin: string
) => {
  if (!isIndriveIndonesia()) {
    window.parent.postMessage(message, legacyTargetOrigin);
    return;
  }
  if (!['SUBMITTED', 'EXIT_APPLICATION', 'TIMEOUT'].includes(message.type))
    return;
  const {loanApplicationStates, dashboard} = store.getState();
  const tile = dashboard.data[0];
  const payload: Record<string, unknown> = {
    loanApplicationId:
      message.payload.loanApplicationId ??
      (loanApplicationStates.loanApplicationId ||
        tile?.ongoingLoanApplicationId ||
        tile?.submittedLoanApplicationId ||
        null),
    status:
      message.payload.status ||
      message.payload.applicationStatus ||
      message.type,
    timestamp: new Date().toISOString(),
  };
  if (
    message.type === 'EXIT_APPLICATION' &&
    'availableLimit' in message.payload
  ) {
    Object.assign(payload, {
      availableLimit: message.payload.availableLimit,
      toHideLimit: message.payload.toHideLimit,
      limitBlocked: message.payload.limitBlocked,
    });
  }
  window.parent.postMessage(
    {type: message.type, payload},
    getIndriveTargetOrigin()
  );
};
